<!--begin::Head-->
<div class="kt-login__head">
	<!-- <span class="kt-login__signup-label">Don't have an account yet?</span>&nbsp;&nbsp;
	<a href="javascript:;" routerLink="/auth/register" class="kt-link kt-login__signup-link">{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}</a> -->
</div>
<!--end::Head-->

<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<div class="kt-login__title">
            <h3>{{'AUTH.FORGOT.PASSWORD' | localize }}</h3>
            <h6>{{'AUTH.FORGOT.PASSWORD.FORM.MESSAGE' | localize}}</h6>
		</div>

		<!-- <kt-auth-notice></kt-auth-notice> -->

		<!--begin::Form-->
	
			<div class="form-group">
				<mat-form-field>
					<mat-label>{{ 'AUTH.INPUT.EMAIL' | localize }}</mat-label>
					<input matInput  placeholder="{{ 'AUTH.INPUT.EMAIL' | localize }}"  [(ngModel)]="email"  autocomplete="off"/>
				
				</mat-form-field>
			</div>
		
			<!--begin::Action-->
			<div class="kt-login__actions">
				<a href="javascript:;" routerLink="../login" class="kt-link kt-login__link-forgot">
					{{ 'AUTH.GOTO.LOGIN' | localize }}
				</a>
				<button (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': (loading$ | async)}" id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary" style="background-color:black;">{{ 'AUTH.FORGOT.PASSWORD.BUTTON' | localize }}</button>
			</div>
			<!--end::Action-->
	
		<!--end::Form-->

		
	</div>
	<!--end::Signin-->
</div>
<!--end::Body-->

